import React, { useEffect, useState } from 'react'

import Container from 'react-bootstrap/Container'

import client from "../../../services/Api";

export default function Faq() {
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        init();
    }, [])

    async function init() {
        try {
            const response = await client.get('/api/faq');
            setQuestions(response.data)
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <section className="Faq" id="faq">
            <h1 className="section-title centered">Faq</h1>

            <Container>
                <ul>
                    {questions.map((question) => {
                        return (
                            <li>
                                <b>
                                    {question['question']}
                                </b>
                                <p>{question['answer']}</p>
                            </li>
                        )
                    })}
                </ul>
            </Container>
        </section>
    )
}